import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import SuperAdminSidebar from './SuperAdminSidebar'
import { HiOutlineBars3 } from 'react-icons/hi2'

const SuperAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const closeSidebar = () => {
    setSidebarOpen(false)
  }

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <SuperAdminSidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      
      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <HiOutlineBars3 className="w-6 h-6 text-gray-600" />
          </button>
          <div className="lg:block hidden">
            <h2 className="text-xl font-semibold text-gray-900">System Management</h2>
          </div>
          <div className="flex items-center space-x-4">
            {/* Can add additional header items here */}
          </div>
        </header>
        
        {/* Main Content */}
        <main className="flex-1 overflow-auto bg-gray-50 p-4 sm:p-6">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden" 
          onClick={closeSidebar}
        />
      )}
    </div>
  )
}

export default SuperAdminLayout

